import type { Route } from 'vue-router'
import { getMetaFromRoute } from '~/utility/route'
import { SearchFilters } from '../../search/schemas'
import { isSearchUrlRoute } from '../../search/isSearchUrlComponent'
import { SearchFiltersUrl } from '../../url/search-filters/SearchFiltersUrl'
import * as campsiteFiltersUrlPart from '../../url/parts/campsiteFiltersUrlPart'
import { ensureArray } from '~/utility/array'
import {
  removeInvalidParams,
  removeUndefinedFields,
  routePathToQuery,
} from './utils'

// when you just need to get the filters from a route
export function routeToFilters(nextRoute: Route): SearchFilters {
  const meta = getMetaFromRoute(nextRoute)
  const nextQuery = nextRoute.query || {}
  const routePathQuery = routePathToQuery(nextRoute)

  const queries = {
    ...removeUndefinedFields(removeInvalidParams(nextQuery)),
    ...removeUndefinedFields(routePathQuery),
  }

  // Special handling for campsite detail pages - treat type params as route-based categories
  if (nextRoute.name === 'campsite-detail') {
    const typeParams = queries.type ? ensureArray(queries.type) : []

    // Get campsite filters with type params as routeBasedCategoryIds
    const campsiteFilters = campsiteFiltersUrlPart.fromQuery(
      { type: queries.type, facet: queries.facet },
      typeParams, // Pass type params as routeBasedCategoryIds
    )

    // Get other filters (excluding campsite filters to avoid double processing)
    const { type, facet, ...otherQueries } = queries
    const otherFilters = SearchFiltersUrl.urlToFilters(otherQueries)

    const filters: SearchFilters = {
      ...otherFilters,
      ...campsiteFilters,
      base: meta.type,
    }

    // remove hierarchy path and base for non-search routes
    delete filters.hierarchyPath
    delete filters.base

    return filters
  }

  // Normal handling for search routes
  const filters: SearchFilters = {
    ...SearchFiltersUrl.urlToFilters(queries),
    base: meta.type,
  }

  return filters
}
